import React from "react";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";

const LayoutDashboard = ({ children }) => {
  return (
    <>
      <div className="flex">
        <Navbar />
        <Sidebar />
        <div className="flex mt-24 w-10/12 ml-auto min-h-screen ">
          {children}
        </div>
      </div>

    </>
  );
};

export default LayoutDashboard;
